var ShopRoutes = (function () {
  /*

   Usage:
- ShopRoutes(pathname, resource_filetype)

   Examples: 
- ShopRoutes(pathname)
- ShopRoutes(pathname, ".js")

*/

  var paths = {
    root_url: Shopify.routes.root,
    account_url: "account",
    account_login_url: "account/login",
    account_logout_url: "account/logout",
    account_register_url: "account/register",
    account_addresses_url: "account/addresses",
    collections_url: "collections",
    all_products_collection_url: "collections/all",
    search_url: "search",
    predictive_search_url: "search/suggest",
    cart_url: "cart",
    cart_add_url: "cart/add",
    cart_change_url: "cart/change",
    cart_clear_url: "cart/clear",
    cart_update_url: "cart/update",
    product_recommendations_url: "recommendations/products",
  };

  var validPathnames = Object.keys(paths);

  var findRoute = function (pathname, resource_filetype) {
    if (!pathname) {
      return;
    }

    if (pathname === "root_url") {
      return paths.root_url;
    }

    var path = paths[pathname];

    if (!path) {
      console.warn("No path found for " + pathname);
      return false;
    }

    resource_filetype = resource_filetype || "";

    return paths.root_url + path + resource_filetype;
  };

  return findRoute;
})();